import React, { Component } from 'react';
import './styles/RMSSelectDrug.css';
import infoImg from './images/info.png';
import infoImgSelected from './images/infoSelected.png';
import backIcon from './images/backIcon.png';
import ModalDrugWebsite from './ModalDrugWebsite';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import VersionService from './VersionService';

class RMSSelectDrug extends Component {
  constructor(props) {
    super(props);

    this.dosageInput = React.createRef();
    this.dosageInputGrams = React.createRef();
    this.notFirstRender = false;

    const rows = [
      {
        id: 1,
        title: 'Baygam',
        header: false,
        url: 'https://www.rxlist.com/baygam-drug.htm',
        value: 0.0893,
        maxVOLValue: 999,
        maxRATEValue: 999,
        maxTFRValue: 999,
      },
      {
        id: 13,
        title:
          'Cutaquig' +
          (this.props.version === 'international'
            ? '® 165 mg/ml'
            : '® 200 mg/mL'),
        header: false,
        url:
          this.props.version === 'international'
            ? 'https://www.octapharma.com/products/product-overview'
            : 'https://www.cutaquigus.com',
        value: 0.0692,
        maxVOLValue: this.props.version === 'international' ? 15 : 40,
        maxRATEValue:
          this.props.version === 'international' ? 15 : 20,
        maxTFRValue:
          this.props.version === 'international' ? 30 : 999,
        showGrams: true,
      },
      {
        id: 12,
        title: `Cuvitru® 200 mg/m${
          this.props.version === 'international' ? 'l' : 'L'
        }`,
        header: false,
        url:
          this.props.version === 'international'
            ? 'https://www.takeda.com/what-we-do/our-products'
            : 'https://www.cuvitru.com',
        url_german: 'https://www.shire.de',
        url_austrian: 'https://www.shire.at',
        value: 0.0692,
        maxVOLValue: this.props.version === 'international' ? 15 : 20,
        maxRATEValue:
          this.props.version === 'international' ? 10 : 10,
        maxTFRValue: 999,
        showGrams: true,
      },
      {
        id: 17,
        title:
          this.props.version === 'international'
            ? 'Empaveli®/Aspaveli®'
            : 'Empaveli®',
        header: false,
        url:
          this.props.version === 'international'
            ? 'https://www.sobi.com/en/key-medicines'
            : 'https://pi.apellis.com/files/PI_Empaveli.pdf',
        value: 0.0692,
        maxVOLValue:
          this.props.version === 'international' ? 20 : 200,
        maxRATEValue: 60,
        maxTFRValue: 240,
        showGrams: false,
      },
      {
        id: 2, // Only for Freedom 60 syringe
        title: 'Gammagard Liquid, 10%',
        header: false,
        url: 'http://www.gammagardliquid.com',
        value: 0.3449,
        maxVOLValue: 20,
        maxVolValueOver: 30,
        maxRATEValue: 15,
        maxRateValueOver: 20,
        maxTFRValue: 160,
        maxTFRValueOver: 999,
      },
      {
        id: 22, // Only for 20mL Syringe
        title: 'Gammagard Liquid, 10%',
        header: false,
        url: 'http://www.gammagardliquid.com',
        value: 0.3449,
        maxVOLValue: 20,
        maxVolValueOver: 30,
        maxRATEValue: 15,
        maxRateValueOver: 20,
        maxTFRValue: 160,
        maxTFRValueOver: 999,
      },
      {
        id: 23, // Only for 30mL Syringe
        title: 'Gammagard Liquid, 10%',
        header: false,
        url: 'http://www.gammagardliquid.com',
        value: 0.3449,
        maxVOLValue: 20,
        maxVolValueOver: 30,
        maxRATEValue: 15,
        maxRateValueOver: 20,
        maxTFRValue: 160,
        maxTFRValueOver: 999,
      },
      {
        id: 3,
        title: 'Gammaked',
        header: false,
        url: 'http://www.gammaked.com',
        value: 0.365,
        maxVOLValue: 69,
        maxRATEValue: 20,
        maxTFRValue: 999,
      },
      {
        id: 4,
        title:
          'Gammanorm' +
          (this.props.version === 'international'
            ? '® 165 mg/ml'
            : ''),
        header: false,
        url:
          this.props.version === 'international'
            ? 'https://www.octapharma.com/products/product-overview'
            : 'http://www.octapharma.com/en/healthcare-professionals/products-therapies/immunotherapy.html#c14898',
        value: 0.1225,
        maxVOLValue:
          this.props.version === 'international' ? 15 : 999,
        maxRATEValue:
          this.props.version === 'international' ? 15 : 999,
        maxTFRValue:
          this.props.version === 'international' ? 100 : 999,
        showGrams: true,
      },
      {
        id: 5,
        title: 'Gamunex-C',
        header: false,
        url: 'http://www.gamunex.com',
        value: 0.365,
        maxVOLValue: 69,
        maxRATEValue: 20,
        maxTFRValue: 999,
      },
      {
        id: 18,
        title: `Hizentra® 200 mg/m${
          this.props.version === 'international' ? 'l' : 'L'
        }`,
        header: false,
        url:
          this.props.version === 'international'
            ? 'https://www.cslbehring.com/products/global-products-list'
            : 'http://www.hizentra.com',
        value: 0.0797,
        maxVOLValue: this.props.version === 'international' ? 15 : 50,
        maxRATEValue:
          this.props.version === 'international' ? 20 : 50,
        maxTFRValue: 999,
        showGrams: true,
      },
      {
        id: 19,
        title: `Hizentra® 20ml/4g Prefilled Syringe 200 mg/m${
          this.props.version === 'international' ? 'l' : 'L'
        }`,
        header: false,
        url:
          this.props.version === 'international'
            ? 'https://www.cslbehring.com/products/global-products-list'
            : 'http://www.hizentra.com',
        value: 0.0797,
        maxVOLValue: this.props.version === 'international' ? 15 : 50,
        maxRATEValue:
          this.props.version === 'international' ? 20 : 50,
        maxTFRValue: 999,
        showGrams: false,
      },
      {
        id: 6,
        title:
          this.props.version === 'international'
            ? 'Hizentra® CIDP'
            : 'Hizentra® 200 mg/mL for CIDP',
        header: false,
        url: 'http://www.hizentra.com',
        value: 0.0797,
        maxVOLValue: 20,
        maxRATEValue: 20,
        maxTFRValue: 999,
        showGrams: true,
      },
      {
        id: 7,
        title:
          this.props.version === 'international'
            ? 'Hizentra® PIDD'
            : 'Hizentra® 200 mg/mL for Primary Immunodeficiency (PID)',
        header: false,
        url: 'http://www.hizentra.com',
        value: 0.0797,
        maxVOLValue: 15,
        maxRATEValue: 15,
        maxTFRValue: 999,
        showGrams: true,
      },
      {
        id: 20,
        title:
          this.props.version === 'international'
            ? 'Hizentra® 50ml Prefilled Syringe for Primary Immunodeficiency (PID)'
            : 'Hizentra® 50mL Prefilled Syringe for Primary Immunodeficiency (PID)',
        header: false,
        url: 'http://www.hizentra.com',
        value: 0.0797,
        maxVOLValue: 15,
        maxRATEValue: 15,
        maxTFRValue: 999,
        showGrams: true,
      },
      {
        id: 21,
        title:
          this.props.version === 'international'
            ? 'Hizentra® 50ml Prefilled Syringe for Chronic Inflammatory Demyelinating Polyneuropathy (CIDP)'
            : 'Hizentra® 50mL Prefilled Syringe for Chronic Inflammatory Demyelinating Polyneuropathy (CIDP)',
        header: false,
        url: 'http://www.hizentra.com',
        value: 0.0797,
        maxVOLValue: 20,
        maxRATEValue: 20,
        maxTFRValue: 999,
        showGrams: true,
      },
      {
        id: 24, // international only version of Hizentra 50ml PFS
        title: 'Hizentra® 50ml/10g Prefilled Syringe 200 mg/ml',
        header: false,
        url: 'http://www.hizentra.com',
        value: 0.0797,
        maxVOLValue: 20,
        maxRATEValue: 20,
        maxTFRValue: 999,
        showGrams: false,
      },
      {
        id: 15,
        title:
          this.props.version === 'international'
            ? 'Hizentra® 20 ml Prefilled Syringe CIDP'
            : 'Hizentra® Prefilled Syringe 200 mg/mL for CIDP',
        header: false,
        url: 'http://www.hizentra.com',
        value: 0.0797,
        maxVOLValue: 20,
        maxRATEValue: 20,
        maxTFRValue: 999,
        showGrams: true,
      },
      {
        id: 16,
        title:
          this.props.version === 'international'
            ? 'Hizentra® 20 ml Prefilled Syringe PIDD'
            : 'Hizentra® Prefilled Syringe 200 mg/mL for Primary Immunodeficiency (PI)',
        header: false,
        url: 'http://www.hizentra.com',
        value: 0.0797,
        maxVOLValue: 15,
        maxRATEValue: 15,
        maxTFRValue: 999,
        showGrams: true,
      },
      {
        id: 8,
        title: 'HyQvia',
        header: false,
        url: 'http://www.hyqvia.com',
        value: 0.3449,
        maxVOLValue: 999,
        maxRATEValue: 160,
        maxTFRValue: 320,
      },
      {
        id: 9,
        title: 'Subcuvia',
        header: false,
        url: 'https://www.hpra.ie/img/uploaded/swedocuments/2162821.PA2004_007_001.6f9936c9-bcf1-43b0-b796-4247a746df12.000001PIL.151130.pdf',
        value: 0.108,
        maxVOLValue: 999,
        maxRATEValue: 999,
        maxTFRValue: 999,
      },
      {
        id: 10,
        title: 'Subgam',
        header: false,
        url: 'https://www.medicines.org.uk/emc/files/pil.5557.pdf',
        value: 0.133662839,
        maxVOLValue: 999,
        maxRATEValue: 999,
        maxTFRValue: 999,
      },
      {
        id: 11,
        title: 'Vivaglobin®',
        header: false,
        url: 'http://www.vivaglobin.com',
        value: 0.097941314,
        maxVOLValue: 15,
        maxRATEValue: 29,
        maxTFRValue: 999,
      },
      {
        id: 14,
        title:
          'Xembify' +
          (this.props.version === 'international'
            ? '® 200 mg/ml'
            : '® 200 mg/mL'),
        header: false,
        url:
          this.props.version === 'international'
            ? 'https://www.grifols.com/en/products-services'
            : 'https://www.xembify.com',
        value: 0.0692,
        maxVOLValue: this.props.version === 'international' ? 15 : 25,
        maxRATEValue:
          this.props.version === 'international' ? 10 : 25,
        maxTFRValue: 25,
        showGrams: true,
      },
    ];

    this.state = {
      rows: rows,
      showModalWindow: false,
      selectedWebsite: '',
      showDrugDropDown: false,
      drugDropDownPlaceholder:
        this.props.version === 'international'
          ? 'Please Select a Medicinal Product'
          : 'Please Select a Drug',
      displayOffLabelWarning: false,
    };
  }

  componentDidMount() {
    // let input = document.getElementById('dosageInput');
    // if(input){
    //     input.focus();
    // }
    this.props.setSelectedDrug({});
  }

  componentDidUpdate(prevProps) {
    if (this.dosageInput.current && !this.notFirstRender) {
      this.dosageInput.current.value = '';
      this.dosageInput.current.focus();
      this.notFirstRender = true;
      if (this.dosageInputGrams.current) {
        this.dosageInputGrams.current.value = '';
      }
    }
  }

  showModal(website, e) {
    this.setState({ selectedWebsite: website });
    this.setState({ showModalWindow: true });
    if (e) {
      e.stopPropagation();
    }
  }

  closeModal(e) {
    this.setState({ showModalWindow: false });
    if (e) {
      e.preventDefault();
    }
  }

  drugSelected = (item) => {
    this.props.setSelectedDrug(item);
    this.props.setWeight('');
    this.setState({
      drugDropDownPlaceholder:
        item.title && item.title.length > 50
          ? item.title.substring(0, 50) + '...'
          : item.title,
    });
    this.setShowDrugDropDown();
    this.notFirstRender = false;

    if (item.id === 17) {
      let input = document.getElementById('dosageInput');
      input.value = '20';
      this.dosageSelected(input.value);
    }
  };

  notifyDatabase = (item) => {
    let now = new Date();
    let now_utc = new Date(
      now.getTime() + now.getTimezoneOffset() * 60000
    );
    let userAgent = window.navigator.userAgent;

    let body = {
      drugName: this.props.selectedDrug.title,
      date: now_utc,
      userAgent: userAgent,
      device: this.props.selectedSyringe.title,
      dosageML: item,
      country: '',
    };

    fetch('https://extreme-ip-lookup.com/json/', {
      method: 'GET',
    }).then(
      (response) => {
        if (response) {
          response.json().then(
            (result) => {
              if (result) {
                body.country = result.countryCode;
              }

              this.notifyDatabaseWithBody(body);
            },
            () => {
              this.notifyDatabaseWithBody(body);
            }
          );
        }
      },
      () => {
        this.notifyDatabaseWithBody(body);
      }
    );
  };

  notifyDatabaseWithBody = (body) => {
    fetch(
      'https://jnp6us085b.execute-api.us-east-2.amazonaws.com/default/addSelectedDrug',
      {
        method: 'post',
        headers: {
          'x-api-key': 'va04Xxh1Jr47FmYyrZIDuacnFVR38gxdS6fomix5',
        },
        body: JSON.stringify(body),
      }
    ).then((response) => {
      if (response.ok) {
        response.json().then((data) => {
          this.props.setDbItemId(data);
        });
      }
    });
  };

  setShowDrugDropDown = () => {
    this.setState({
      showDrugDropDown: !this.state.showDrugDropDown,
    });
  };

  changeImage = (item, hover) => {
    let element = document.getElementById('img_' + item.id);
    if (element && hover) {
      element.src = infoImgSelected;
    } else if (element && !hover) {
      element.src = infoImg;
    }
  };

  focusInput = (input) => {
    if (input) {
      input.focus();
    }
  };

  setWeight = (value) => {
    this.props.setWeight(value);
  };

  checkValue = (e) => {
    if (e.keyCode === 13) {
      if (this.isDosageInputValid()) {
        this.dosageSelected(e.target.value);
      }
    } else {
      let dosageInputGrams = document.getElementById(
        'dosageInputGrams'
      );
      if (dosageInputGrams) {
        if (
          this.props.selectedDrug.id === 13 ||
          this.props.selectedDrug.id === 4
        ) {
          dosageInputGrams.value =
            Math.round((e.target.value / 6) * 10) / 10;
        } else if (this.props.selectedDrug.id === 17) {
          const gramValue = e.target.value / 18.52;
          if (gramValue < 1) {
            dosageInputGrams.value =
              Math.round(gramValue * 100) / 100;
          } else {
            dosageInputGrams.value = Math.round(gramValue * 10) / 10;
          }
        } else {
          dosageInputGrams.value =
            Math.round((e.target.value / 5) * 10) / 10;
        }
      }
      if (e.target.value < 0 || e.target.value > 1000) {
        this.setState({ displayOffLabelWarning: true });
      } else {
        this.setState({ displayOffLabelWarning: false });
      }
    }
  };

  setMlValue = (e) => {
    if (e.keyCode === 13) {
      let dosageInput = document.getElementById('dosageInput');
      this.dosageSelected(dosageInput.value);
    } else {
      if (e.target.value && e.target.value.length > 0) {
        let dosageInput = document.getElementById('dosageInput');
        if (
          this.props.selectedDrug.id === 13 ||
          this.props.selectedDrug.id === 4
        ) {
          dosageInput.value =
            Math.round(e.target.value * 6 * 10) / 10;
        } else if (this.props.selectedDrug.id === 17) {
          dosageInput.value =
            Math.round(e.target.value * 18.52 * 10) / 10;
        } else {
          dosageInput.value = e.target.value * 5;
        }
        if (
          dosageInput.value &&
          (dosageInput.value < 0 || dosageInput.value > 1000)
        ) {
          this.setState({ displayOffLabelWarning: true });
        } else {
          this.setState({ displayOffLabelWarning: false });
        }
      }
    }
  };

  dosageSelected = (item) => {
    this.notifyDatabase(item);
    this.props.setSelectedDosage(item);
    this.props.changePage('RMSResults');
  };

  isDosageInputValid = () => {
    let input = document.getElementById('dosageInput');
    let inputGrams = document.getElementById('dosageInputGrams');

    if (
      !input ||
      input.value.length === 0 ||
      (inputGrams &&
        (inputGrams.value.length === 0 ||
          isNaN(inputGrams.value) ||
          parseFloat(inputGrams.value) <= 0)) ||
      isNaN(input.value) ||
      parseFloat(input.value) <= 0
    ) {
      return false;
    }

    return true;
  };

  showDrug = (item) => {
    if (this.props.version === 'international') {
      switch (this.props.selectedSyringe.id) {
        case 1:
          if (
            item.id === 13 ||
            item.id === 12 ||
            item.id === 18 ||
            item.id === 14 ||
            item.id === 24
          ) {
            return true;
          }
          break;
        case 2:
          if (
            item.id === 17 ||
            item.id === 12 ||
            item.id === 18 ||
            item.id === 19
          ) {
            return true;
          }
          break;
        case 3:
          if (item.id === 12 || item.id === 18) {
            return true;
          }
          break;
        default:
          break;
      }
    } else {
      switch (this.props.selectedSyringe.id) {
        case 1:
          if (
            item.id === 13 ||
            item.id === 12 ||
            item.id === 2 ||
            item.id === 7 ||
            item.id === 6 ||
            item.id === 14 ||
            item.id === 20 ||
            item.id === 21
          ) {
            return true;
          }
          break;
        case 2:
          if (
            item.id === 17 ||
            item.id === 16 ||
            item.id === 15 ||
            item.id === 22
          ) {
            return true;
          }
          break;
        case 3:
          if (item.id === 23) {
            return true;
          }
          break;
      }
    }

    return false;
  };

  getVolumeInputLabel = () => {
    const mlStr = this.props.version === 'international' ? 'l' : 'L';
    if (
      this.props.selectedDrug.id === 19 ||
      this.props.selectedDrug.id === 24
    ) {
      return 'Select Prefilled Syringe (PFS) Dose';
    } else if (
      this.props.selectedDrug.id !== 22 &&
      this.props.selectedDrug.id !== 23
    ) {
      return 'Enter amount in m' + mlStr;
    } else {
      return 'Select amount in m' + mlStr;
    }
  };

  render() {
    let linkItems = this.state.rows.map((item) => {
      if (this.showDrug(item)) {
        return (
          <div
            key={item.id}
            className="row drug-container"
            onClick={() => this.drugSelected(item)}
            onMouseEnter={() => this.changeImage(item, true)}
            onMouseLeave={() => this.changeImage(item, false)}
          >
            <div className=" col-lg-12 col-xs-12">
              <a>
                {item.title}{' '}
                <img
                  id={'img_' + item.id}
                  onClick={(e) => this.showModal(item.url, e)}
                  src={infoImg}
                  alt="info"
                />
              </a>
            </div>
          </div>
        );
      }
    });

    let content = '';
    let ddIcon = <i className="fa fa-caret-down"></i>;

    if (this.state.showDrugDropDown) {
      content = linkItems;
    }

    if (this.state.showDrugDropDown) {
      ddIcon = <i className="fa fa-caret-up"></i>;
    }

    let dosageLabel = '';
    let resultsButton = '';
    let dosageInput = '';
    let dosageInputGrams = '';
    let dosageDrugTitle =
      this.props.version === 'international'
        ? 'Please Select a Medicinal Product'
        : 'Please Select a Drug';
    let dosageGramsContainer = '';
    let weightSelector = '';
    let weightSelectorLabel = '';
    let dosageWarning = '';

    if (this.props.selectedDrug && this.props.selectedDrug.id === 2) {
      weightSelectorLabel = (
        <div className="row dosage-label">
          <div className="col-lg-12">
            <span>Select Weight:</span>
          </div>
        </div>
      );
      weightSelector = (
        <div className="weightbutton-div">
          <button
            className={
              'weightbutton ' +
              (this.props.selectedWeight === 'under'
                ? 'weightbutton-active'
                : '')
            }
            onClick={() => this.setWeight('under')}
          >
            Under 40kg
          </button>
          <button
            className={
              'weightbutton ' +
              (this.props.selectedWeight === 'over'
                ? 'weightbutton-active'
                : '')
            }
            onClick={() => this.setWeight('over')}
          >
            Over 40kg
          </button>
        </div>
      );
    } else {
      weightSelector = '';
      weightSelectorLabel = '';
    }

    if (this.props.selectedDrug.id === 22) {
      dosageInput = (
        <select
          className="drug-vol-select"
          ref={this.dosageInput}
          onChange={(e) => this.dosageSelected(e.target.value)}
        >
          <option value="20">
            20 {this.props.version === 'international' ? 'ml' : 'mL'}
          </option>
          <option value="60">
            60 {this.props.version === 'international' ? 'ml' : 'mL'}
          </option>
          <option value="100">
            100 {this.props.version === 'international' ? 'ml' : 'mL'}
          </option>
        </select>
      );
    } else if (this.props.selectedDrug.id === 23) {
      dosageInput = (
        <select
          className="drug-vol-select"
          ref={this.dosageInput}
          onChange={(e) => this.dosageSelected(e.target.value)}
        >
          <option value="20">
            20 {this.props.version === 'international' ? 'ml' : 'mL'}
          </option>
          <option value="30">
            30 {this.props.version === 'international' ? 'ml' : 'mL'}
          </option>
        </select>
      );
    } else if (this.props.selectedDrug.id === 19) {
      dosageInput = (
        <select
          className="drug-vol-select"
          ref={this.dosageInput}
          onChange={(e) => this.dosageSelected(e.target.value)}
        >
          <option value="20">
            20 {this.props.version === 'international' ? 'ml' : 'mL'}
            /4g (1 PFS)
          </option>
          <option value="40">
            40 {this.props.version === 'international' ? 'ml' : 'mL'}
            /8g (2 PFS)
          </option>
          <option value="60">
            60 {this.props.version === 'international' ? 'ml' : 'mL'}
            /12g (3 PFS)
          </option>
          <option value="80">
            80 {this.props.version === 'international' ? 'ml' : 'mL'}
            /16g (4 PFS)
          </option>
          <option value="100">
            100 {this.props.version === 'international' ? 'ml' : 'mL'}
            /20g (5 PFS)
          </option>
          <option value="120">
            120 {this.props.version === 'international' ? 'ml' : 'mL'}
            /24g (6 PFS)
          </option>
          <option value="140">
            140 {this.props.version === 'international' ? 'ml' : 'mL'}
            /28g (7 PFS)
          </option>
          <option value="160">
            160 {this.props.version === 'international' ? 'ml' : 'mL'}
            /32g (8 PFS)
          </option>
          <option value="180">
            180 {this.props.version === 'international' ? 'ml' : 'mL'}
            /36g (9 PFS)
          </option>
          <option value="200">
            200 {this.props.version === 'international' ? 'ml' : 'mL'}
            /40g (10 PFS)
          </option>
        </select>
      );
    } else if (this.props.selectedDrug.id === 24) {
      dosageInput = (
        <select
          className="drug-vol-select"
          ref={this.dosageInput}
          onChange={(e) => this.dosageSelected(e.target.value)}
        >
          <option value="50">
            50 {this.props.version === 'international' ? 'ml' : 'mL'}/
            10g (1 PFS)
          </option>
          <option value="100">
            100 {this.props.version === 'international' ? 'ml' : 'mL'}
            / 20g (2 PFS)
          </option>
          <option value="150">
            150 {this.props.version === 'international' ? 'ml' : 'mL'}
            / 30g (3 PFS)
          </option>
          <option value="200">
            200 {this.props.version === 'international' ? 'ml' : 'mL'}
            / 40g (4 PFS)
          </option>
          <option value="250">
            250 {this.props.version === 'international' ? 'ml' : 'mL'}
            / 50g (5 PFS)
          </option>
          <option value="300">
            300 {this.props.version === 'international' ? 'ml' : 'mL'}
            / 60g (6 PFS)
          </option>
          <option value="350">
            350 {this.props.version === 'international' ? 'ml' : 'mL'}
            / 70g (7 PFS)
          </option>
          <option value="400">
            400 {this.props.version === 'international' ? 'ml' : 'mL'}
            / 80g (8 PFS)
          </option>
        </select>
      );
    } else if (
      this.props.selectedDrug &&
      this.props.selectedDrug.title &&
      this.props.selectedDrug.id !== 17
    ) {
      dosageInput = (
        <input
          id="dosageInput"
          ref={this.dosageInput}
          type="text"
          placeholder={
            this.props.version === 'international' ? 'ml' : 'mL'
          }
          onKeyUp={(e) => this.checkValue(e)}
        />
      );
      dosageInputGrams = (
        <input
          id="dosageInputGrams"
          ref={this.dosageInputGrams}
          type="text"
          placeholder="g"
          onKeyUp={(e) => this.setMlValue(e)}
        />
      );
      dosageDrugTitle = (
        <span>
          {this.props.version === 'international'
            ? 'Medicinal Product'
            : 'Drug'}
          : {this.props.selectedDrug.title}
        </span>
      );
    } else {
      dosageInput = (
        <input
          disabled
          id="dosageInput"
          type="text"
          placeholder={
            this.props.version === 'international' ? 'ml' : 'mL'
          }
          onKeyUp={(e) => this.checkValue(e)}
        />
      );
      dosageInputGrams = (
        <input
          disabled
          id="dosageInputGrams"
          type="text"
          placeholder="g"
          onKeyUp={(e) => this.setMlValue(e)}
        />
      );
    }

    if (
      this.props.selectedDrug.id &&
      this.props.version !== 'international'
    ) {
      if (
        this.props.selectedDrug.id === 13 ||
        this.props.selectedDrug.id === 14 ||
        this.props.selectedDrug.id === 15 ||
        this.props.selectedDrug.id === 16 ||
        this.props.selectedDrug.id === 17
      ) {
        dosageWarning = (
          <div className="row dsg-warn">
            <div className="col-lg-12 drug-warning">
              {/* <span>The use of this drug with the Freedom Infusion System is pending<br/>510k clearance and not currently indicated in the United States.</span> */}
            </div>
          </div>
        );
      }
      if (
        (this.props.selectedDrug.id === 20 ||
          this.props.selectedDrug.id === 21) &&
        this.props.version === 'us'
      ) {
        dosageWarning = (
          <div className="row dsg-warn">
            <div className="col-lg-12 drug-warning">
              <span>
                The use of this drug with the Freedom Infusion System
                is
                <br />
                not indicated for use outside of the United States.
              </span>
            </div>
          </div>
        );
      } else if (
        this.props.selectedDrug.id !== 12 &&
        this.props.selectedDrug.id !== 6 &&
        this.props.selectedDrug.id !== 7 &&
        this.props.selectedDrug.id !== 2 &&
        this.props.selectedDrug.id !== 20 &&
        this.props.selectedDrug.id !== 21 &&
        this.props.selectedDrug.id !== 24
      ) {
        dosageWarning = (
          <div className="row dsg-warn">
            <div className="col-lg-12 drug-warning">
              <span>
                The use of this{' '}
                {this.props.version === 'international'
                  ? 'medicinal product'
                  : 'drug'}{' '}
                with the Freedom Infusion System is
                <br />
                not indicated for use in the United States.
              </span>
            </div>
          </div>
        );
      }
    }

    if (this.state.displayOffLabelWarning) {
      dosageLabel = (
        <div className="row">
          <div className="col-lg-12 dosage-label-warning">
            <span>WARNING: DOSAGE AMOUNT IS OFF LABEL!</span>
          </div>
        </div>
      );

      // if((this.props.selectedDrug && this.props.selectedDrug.id !== 2) || this.props.selectedWeight !== '') {
      if (this.props.selectedDrug) {
        resultsButton = (
          <div>
            <div className="row results-button results-button-warning">
              <div className="col-lg-12">
                <span>Results</span>
              </div>
            </div>
            {this.props.version === 'international' && (
              <div className="row">
                <div className="col-lg-12 drug-warning">
                  <span>
                    Please refer to the medicinal product labelling
                    for initial flow rate parameters as they may
                    differ from maintenance parameters.
                  </span>
                </div>
              </div>
            )}
          </div>
        );
      }
    } else {
      dosageLabel = (
        <div className="row">
          <div className="col-lg-12 dosage-label">
            <span>{this.getVolumeInputLabel()}</span>
          </div>
        </div>
      );

      let input = document.getElementById('dosageInput');
      let inputGrams = document.getElementById('dosageInputGrams');

      // if (((input && input.value.length > 0) || (inputGrams && inputGrams.value.length > 0)) &&
      //     ((this.props.selectedDrug && this.props.selectedDrug.id !== 2) || this.props.selectedWeight !== '')) {
      if (
        ((input && input.value.length > 0) ||
          (inputGrams && inputGrams.value.length > 0)) &&
        this.props.selectedDrug
      ) {
        resultsButton = (
          <div>
            <div
              className={
                'row results-button' +
                (this.isDosageInputValid()
                  ? ''
                  : ' results-button-disabled')
              }
              onClick={() => {
                if (this.isDosageInputValid()) {
                  this.dosageSelected(input.value);
                }
              }}
            >
              <div className="col-lg-12">
                <span>Results</span>
              </div>
            </div>
            {this.props.version === 'international' && (
              <div className="row">
                <div className="col-lg-12 drug-warning">
                  <span>
                    Please refer to the medicinal product labelling
                    for initial flow rate parameters as they may
                    differ from maintenance parameters.
                  </span>
                </div>
              </div>
            )}
          </div>
        );
      } else {
        resultsButton = '';
      }
    }

    if (
      this.props.selectedDrug &&
      this.props.selectedDrug.showGrams
    ) {
      dosageGramsContainer = (
        <div className="row grams-row">
          <div className="col-lg-12">
            <div className="dosage-label">
              <span>Enter amount in g</span>
            </div>
            <div className="row">
              <div className="col-lg-12 dosage-input">
                {dosageInputGrams}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      dosageGramsContainer = '';
    }

    return (
      <div className="row">
        <div className="col-lg-12 col-xs-12 drug-wrapper">
          <div className="drug-bg"></div>
          <div className="row">
            <div className="col-lg-2 col-xs-12 drug-title">
              <h4>
                <img
                  className="backbutton"
                  src={backIcon}
                  alt="Go Back"
                  onClick={() =>
                    this.props.changePage('RMSSelectSyringeDriver')
                  }
                />
              </h4>
            </div>
            <div className="col-lg-8 col-xs-12 drug-title">
              <h4 className="page-title">
                {VersionService.getVersionLabel()}
              </h4>
            </div>
          </div>
          <div className="row drug-section-container">
            <div className="col-lg-6">
              <div className="row">
                <div
                  className="col-lg-12 drug-dd-selector"
                  onClick={() => this.setShowDrugDropDown()}
                >
                  <span>
                    {this.state.drugDropDownPlaceholder}
                    <span className="drug-dd-caret">{ddIcon}</span>
                  </span>
                </div>
              </div>
              <div className="row drug-row">
                <div className="col-lg-12 drug-dd">{content}</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="row">
                <div className="col-lg-12">
                  <div className="row">
                    <div className="col-lg-12 dosage-drug-label">
                      {dosageDrugTitle}
                    </div>
                  </div>
                  {dosageWarning}
                  {dosageLabel}
                  <div className="row">
                    <div className="col-lg-12 dosage-input">
                      {dosageInput}
                    </div>
                  </div>
                  {/*<div className="row">*/}
                  {/*<div className="col-lg-6 offset-lg-3">*/}
                  {/*{resultsButton}*/}
                  {/*</div>*/}
                  {/*</div>*/}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 drug-warning">
                  <span>
                    Please refer to the{' '}
                    {this.props.version === 'international'
                      ? 'medicinal'
                      : 'drug'}{' '}
                    product labelling for initial dose
                    <br />
                    parameters as they may differ from maintenance
                    parameters.
                  </span>
                </div>
              </div>
              {dosageGramsContainer}
              {/*<div className="row weight-section">*/}
              {/*<div className="col-lg-12">*/}
              {/*{weightSelectorLabel}*/}
              {/*<div className="row">*/}
              {/*{weightSelector}*/}
              {/*</div>*/}
              {/*</div>*/}
              {/*</div>*/}
              <div className="row">
                <div className="col-lg-12">
                  <div className="row">
                    <div className="col-lg-6 offset-lg-3">
                      {resultsButton}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-xs-12 mt-5 reference-hdr">
              <p>
                The calculator is intended for reference only. Always
                refer to the Instructions for Use for the infusion
                system and the{' '}
                {this.props.version !== 'us'
                  ? 'medicinal product'
                  : 'drug'}
                /biologic prescribing information (PI) prior to using
                the device.
              </p>
            </div>
          </div>
        </div>
        <ModalDrugWebsite
          showModal={() => this.showModal()}
          closeModal={(e) => this.closeModal(e)}
          showModalWindow={this.state.showModalWindow}
          website={this.state.selectedWebsite}
        />
      </div>
    );
  }
}

export default RMSSelectDrug;



// WEBPACK FOOTER //
// ./src/RMSSelectDrug.js